import PropTypes from 'prop-types';
import React from 'react';
import { Flex, Tag, Tooltip } from 'antd';
import BaseTag from '../../_ui/BaseTag/BaseTag';

function ListOfPIForActor({
  publicInterfaces = [],
  className,
}) {
  return (
    <Flex gap={5} className={className} wrap>
      {publicInterfaces.map((item) => (
        <Tooltip title={item.service_name}>
          <BaseTag
            color="cyan"
            className="max-width-200px"
          >
            <p className="truncate">{item.service_name}</p>
          </BaseTag>
        </Tooltip>
      ))}
    </Flex>
  );
}

export default ListOfPIForActor;

ListOfPIForActor.propTypes = {
  className: PropTypes.string,
  publicInterfaces: PropTypes.array,
};
